import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import LocalEntregaModel from "@/models/transporte/localEntregaModel";
import localEntregaService from "@/services/transporte/localEntregaService";

import ListComponentBase from "../listComponentBase";

@Component
export default class LocalEntregaListComponent extends ListComponentBase<LocalEntregaModel> {
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("codigo", this.$t("__.ts.codigo"), GridColumnType.String),
            new GridColumn("descricao", this.$t("__.ts.descricao"), GridColumnType.String),
            new GridColumn("taxa", this.$t("__.Crud.localentrega.list_vue_html.taxa"), GridColumnType.Money),
            new GridColumn("ativo", "Ativo", GridColumnType.Boolean),
        ];
    }

    private beforeMount() {
        this.setPropsCached(localEntregaService, "localentrega", "codigo");
    }
}
